export const InfoIcon = () => {
	return (
		<div className="flex flex-grow-0 flex-shrink-0 items-center justify-center w-28 h-28 rounded-full bg-cta-default text-white text-sm font-semibold">
			i
		</div>
	)
}
